import React, { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Stepped loader. A CSS spin stays on the first frame while the page fade is running,
 * so every switch turns the icon the same way: 45 degrees every 70ms.
 */
export function SwitchSpinner({ className = 'h-5 w-5' }: { className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let angle = 0;
    const timer = window.setInterval(() => {
      angle = (angle + 45) % 360;
      el.style.transform = `rotate(${angle}deg)`;
    }, 70);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <span ref={ref} className="inline-flex" style={{ transformOrigin: 'center' }}>
      <Loader2 className={className} aria-hidden />
    </span>
  );
}
